<template>
    <div id="app-container" :style="containerStyle">
        <div id="app-content" :style="contentStyle">
            <router-view/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            containerStyle: {
                width: '100vw',
                height: '100vh'
            },
            contentStyle: {
                width: '100%',
                height: '100%'
            },
            resizeFn: null,

        }
    },
    mounted() {
        this.applyScaling();
        this.resizeFn = this.$debounce(this.applyScaling, 100);
        window.addEventListener('resize', this.resizeFn);
    },
    methods: {
        applyScaling() {
            // 直接使用窗口宽高，不再固定1920x1080
            this.contentStyle = {
                width: '100%',
                height: '100%',
                transform: 'none',
                left: '0',
                top: '0'
            };
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeFn);
    }
}
</script>

<style lang="less">
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body, #app-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
    //background: #0a1a3a; // 改为深蓝色背景，与截图一致
}

#app-container {
    position: fixed;
    top: 0;
    left: 0;
    //background: #0a1a3a;
}

#app-content {
    position: absolute;
    width: 100%;
    height: 100%;
    //background: #0a1a3a;
    padding: 0; // 移除内边距
    margin: 0; // 移除外边距

    /* 确保所有子元素继承100%宽度 */
    & > * {
        width: 100%;
    }

    /* 2K屏字体增强 */
    @media (min-width: 2560px) {
        .chart-title, .time-display {
            font-size: 18px !important;
        }
    }

    /* 关键组件保护 */
    .map-container {
        position: absolute !important;
        width: 100% !important;
        height: 100% !important;
    }

    /* 底部图表区适配 */
    .bottom-charts {
        position: absolute;
        bottom: 10px;
        width: calc(100% - 20px);
        left: 10px;
    }
}

/* 隐藏所有滚动条 */
::-webkit-scrollbar {
    display: none;
}
</style>